const KEY = "ot_chart_quiz_v1";
const EMPTY = () => ({ lastDate: null, streak: 0, best: 0, bestScore: 0, played: {} });

const load = (key = KEY) => {
  try { return JSON.parse(localStorage.getItem(key)) || EMPTY(); }
  catch { return EMPTY(); }
};

const save = (s, key = KEY) => localStorage.setItem(key, JSON.stringify(s));

const dayBefore = (iso) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
};

export const getQuizState = (key) => load(key);

export const getTodayResult = (date, key) => load(key).played?.[date] || null;

export const recordQuizResult = (date, result, key) => {
  const s = load(key);
  if (!s.played[date]) {
    s.streak = s.lastDate === dayBefore(date) ? s.streak + 1 : s.lastDate === date ? s.streak : 1;
    s.lastDate = date;
    s.best = Math.max(s.best || 0, s.streak);
    s.bestScore = Math.max(s.bestScore || 0, result.total);
    s.played[date] = result;
    const keys = Object.keys(s.played).sort();
    while (keys.length > 60) delete s.played[keys.shift()];
    save(s, key);
  }
  return s;
};

export const currentStreak = (today, key) => {
  const s = load(key);
  if (!s.lastDate) return 0;
  return s.lastDate === today || s.lastDate === dayBefore(today) ? s.streak : 0;
};
